/** Keep in sync with `index.html` gtag config measurement ID. */
const GA4_MEASUREMENT_ID = "G-FRCDBRC0QX";

/**
 * Virtual page view for SPA routes (Meta Pixel + GA4).
 * Full HTML loads still get PageView from `index.html`; client navigations do not.
 */
export function trackMarketingPageView(): void {
  if (typeof window === "undefined") return;

  window.fbq?.("track", "PageView");

  const { gtag } = window;
  if (typeof gtag === "function") {
    gtag("config", GA4_MEASUREMENT_ID, {
      page_path: `${window.location.pathname}${window.location.search}`,
      page_title: document.title,
    });
  }
}

/** X (Twitter) conversion event — fires on community form submit success (200). */
export function trackTwitterLead(): void {
  if (typeof window === "undefined") return;
  window.twq?.("event", "tw-re4dq-re4e0", {});
}

/** Meta Lead — same as `lead-form` successful validation, before API POST. */
export function trackMarketingLead(): void {
  if (typeof window === "undefined") return;
  window.fbq?.("track", "Lead");
}
